import styled from 'styled-components';
import { ToolbarParent } from './toolbarParent';

/**
 * @deprecated use HorizontalToolbarLayout instead
 */
export const FieldInlineLayout = styled(ToolbarParent).attrs({
  layoutType: 'horizontal',
})`
  & > :not(:first-child) {
    margin-left: -1px;
  }
  display: flex;
  align-items: stretch;
`;

export const HorizontalToolbarLayout = styled(ToolbarParent).attrs({
  layoutType: 'horizontal',
})`
  & > :not(:first-child) {
    margin-left: -1px;
  }
  display: flex;
  align-items: stretch;
`;

export const VerticalToolbarLayout = styled(ToolbarParent).attrs({
  layoutType: 'vertical',
})`
  & > :not(:first-child) {
    margin-top: -1px;
  }
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const HorizontalInnerToolbarLayout = styled(ToolbarParent).attrs({
  layoutType: 'inner',
})`
  & > :not(:first-child) {
    margin-left: -1px;
  }
  display: flex;
  align-items: stretch;
`;

export const VerticalInnerToolbarLayout = styled(ToolbarParent).attrs({
  layoutType: 'inner',
})`
  & > :not(:first-child) {
    margin-top: -1px;
  }
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
